var _path, _linearGradient, _path2, _linearGradient2, _path3, _linearGradient3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8AddressBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1783bd",
    d: "M41,6v36c0,1.105-0.895,2-2,2h-5V4h5C40.105,4,41,4.895,41,6z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "UrHWIotp8XXri5KoWQnF5a",
    x1: 595.856,
    x2: 595.856,
    y1: -363.305,
    y2: -360.163,
    gradientTransform: "rotate(-90 509.067 110.79)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.441,
    stopColor: "#999998"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.653,
    stopColor: "#c1c1c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3f3f3"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#UrHWIotp8XXri5KoWQnF5a)",
    d: "M39,6v36c0,1.105-0.895,2-2,2h-6V4h6C38.105,4,39,4.895,39,6z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "UrHWIotp8XXri5KoWQnF5b",
    x1: 3.638,
    x2: 15.691,
    y1: 8.572,
    y2: 41.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0176d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16538c"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#UrHWIotp8XXri5KoWQnF5b)",
    d: "M7,6v36c0,1.105,0.895,2,2,2h2V4H9C7.895,4,7,4.895,7,6z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "UrHWIotp8XXri5KoWQnF5c",
    x1: 16.78,
    x2: 31.215,
    y1: 5.154,
    y2: 44.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33bef0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22a5e2"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#UrHWIotp8XXri5KoWQnF5c)",
    d: "M35,4H11v40h24c1.105,0,2-0.895,2-2V6C37,4.895,36.105,4,35,4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.525,27.527h-0.064c-0.498,1.358-1.4,2.037-2.709,2.037c-0.981,0-3.274-0.419-3.274-4.02 c0-3.318,1.848-5.502,4.255-5.502c1.059,0,1.724,0.416,1.994,1.248h0.043l0.107-1.056h2.399c-0.32,3.028-0.48,5.008-0.48,5.94 c0,0.995,0.27,1.493,0.81,1.493c0.569,0,1.962-0.642,1.962-4.084c0-1.664-0.791-5.684-6.025-5.684c-3.801,0-7.091,2.976-7.091,7.315 c0,2.927,1.555,6.377,6.718,6.377c1.6,0,3.064-0.306,4.393-0.917v2.037c-1.216,0.519-2.78,0.778-4.692,0.778 c-4.057,0-8.872-2.17-8.872-8.318C15,20.565,18.252,16,24.416,16C28.791,16,33,18.39,33,23.464c0,3.521-1.988,6.1-5.044,6.1 C26.032,29.564,25.505,28.154,25.525,27.527z M24.107,21.897c-1.732,0-2.165,2.534-2.165,3.626c0,1.872,1.038,2.165,1.472,2.165 c0.942,0,2.154-0.865,2.154-3.956c0-0.569-0.133-1.017-0.4-1.344C24.901,22.06,24.547,21.897,24.107,21.897z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8AddressBook);
export default __webpack_public_path__ + "static/media/icons8-address-book.a7a4bd7a1057e69e9996ee8d131ba743.svg";
export { ForwardRef as ReactComponent };